import { SortDirectionCapital } from '../../../../types'
import { getInitialPaginationDataFromKeys } from '../../../../utils'
import {
  AccountColumnsEnum,
  AccountsDataType,
  AccountColumnsKeys,
  AccountFiltersEnum,
} from '../api/types'

export const allColumns = Object.values(AccountColumnsEnum)
export const initialFilters: AccountFiltersEnum[] = []

const initialState = {
  list: [] as AccountsDataType['data'],
  pagination: {
    ...(getInitialPaginationDataFromKeys<AccountColumnsKeys, AccountFiltersEnum[]>(
      allColumns,
      initialFilters,
    ) as AccountsDataType['meta']),
    orderBy: 'createdAt' as AccountColumnsKeys,
    order: SortDirectionCapital.desc,
  },
  loading: 'idle',
}

export type StateType = typeof initialState

export default initialState
